import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { SpaceInvadersContainer } from '@/styled';

const NotFoundErrorPage = lazy(
  () =>
    import(
      /* webpackChunkName:'notFoundPage' */
      '@/pages/NotFoundErrorPage'
    ),
);

const EasterEggErrorPage = lazy(
  () =>
    import(
      /* webpackChunkName:'easterEggPage' */
      '@/pages/EasterEggErrorPage'
    ),
);

const SpaceInvadersPage = lazy(
  () =>
    import(
      /* webpackChunkName:'spaceInvadersPage' */
      '@/components/SpaceInvaders'
    ),
);

const Router = () => {
  const [isEasterEggPageActive, setIsEasterEggPageActive] = useState(false);
  const [keys, setKeys] = useState<string[]>([]);

  const handleKeyDown = (e: KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setKeys((currKeys) => [...currKeys, e.code]);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (isEasterEggPageActive) {
      return;
    }

    const last4Keys = keys.slice(-4);
    // Check for 'burn'
    if (last4Keys.join('') === 'KeyBKeyUKeyRKeyN') {
      setIsEasterEggPageActive(true);
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, [isEasterEggPageActive, keys]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/404/burn"
          element={
            <Suspense fallback={null}>
              <SpaceInvadersContainer open>
                <SpaceInvadersPage />
              </SpaceInvadersContainer>
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={null}>
              {isEasterEggPageActive ? (
                <EasterEggErrorPage />
              ) : (
                <NotFoundErrorPage />
              )}
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
